"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeField = exports.FIELD_SETTINGS = exports.makeError = exports.makeLabel = void 0;
var react_1 = __importStar(require("react"));
var uuid_1 = require("uuid");
var styled_components_1 = __importDefault(require("styled-components"));
var units_1 = require("../units");
var unitToStyle_1 = require("../unitToStyle");
var Column = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: ", ";\n  justify-content: flex-start;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: ", ";\n  justify-content: flex-start;\n\n  ", "\n"])), function (p) { return p.align; }, function (p) { return (p.basis !== undefined ? "flex: 1 1 calc(100% - " + p.basis + ");" : ''); });
var Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n\n  flex-basis: 100%;\n  flex-grow: 1;\n  flex-shrink: 1;\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n\n  flex-basis: 100%;\n  flex-grow: 1;\n  flex-shrink: 1;\n"])), function (p) { return p.direction; }, function (p) { return (p.direction === 'row' ? 'center' : 'flex-start'); }, function (p) { return (p.direction.includes('reverse') ? 'flex-end' : 'flex-start'); });
// Function for making a label component that is compatible with field
exports.makeLabel = function (_a) {
    var spacing = _a.spacing, font = _a.font, palette = _a.palette;
    return styled_components_1.default.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  /* Remove margin */\n  margin: 0;\n\n  /* Add artificial padding bottom to correct for error height */\n  padding-bottom: 1em;\n\n  /* Add spacing with padding so there's a larger clickarea */\n  ", "\n\n  /* Style and color font  */\n  ", "\n  color: ", ";  \n\n  ", "\n  ", "\n"], ["\n  /* Remove margin */\n  margin: 0;\n\n  /* Add artificial padding bottom to correct for error height */\n  padding-bottom: 1em;\n\n  /* Add spacing with padding so there's a larger clickarea */\n  ", "\n\n  /* Style and color font  */\n  ", "\n  color: ", ";  \n\n  ", "\n  ", "\n"
        // Function for making an Error component that is compatible with field
    ])), function (p) { return "padding-" + p.padding + ": " + spacing + ";"; }, unitToStyle_1.fontToStyle(font), palette.text, function (p) { return (p.align === undefined ? '' : "align-self: " + p.align + ";"); }, function (p) { return (p.basis === undefined ? '' : "flex: 1 1 " + p.basis + ";"); });
};
// Function for making an Error component that is compatible with field
exports.makeError = function (_a) {
    var spacing = _a.spacing, font = _a.font, palette = _a.palette;
    return styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  /* Style and color font  */\n  ", "\n  color: ", ";\n\n  /* Remove margin */\n  margin: 0;\n  padding-top: ", ";\n  \n  /* Make the error atleast one line-height high */\n  line-height: 100%;\n  min-height: 1em; \n"], ["\n  /* Style and color font  */\n  ", "\n  color: ", ";\n\n  /* Remove margin */\n  margin: 0;\n  padding-top: ", ";\n  \n  /* Make the error atleast one line-height high */\n  line-height: 100%;\n  min-height: 1em; \n"])), unitToStyle_1.fontToStyle(font), palette.text, spacing);
};
// The properties that should be added to settings of any Field* that uses this Field internally
exports.FIELD_SETTINGS = {
    label: {
        type: 'Object',
        properties: {
            placement: { type: 'String', options: ['none', 'top', 'left', 'right'], default: 'none' },
            align: { type: 'String', options: ['start', 'center', 'end'], default: 'start' },
            fixedWidth: units_1.UNITS.MEASURE.asOptional(),
            font: units_1.UNITS.FONT,
            spacing: units_1.UNITS.MEASURE,
            palette: { type: 'Object', properties: { text: units_1.UNITS.COLOR } }
        }
    },
    error: {
        type: 'Object',
        properties: {
            font: units_1.UNITS.FONT,
            spacing: units_1.UNITS.MEASURE,
            palette: { type: 'Object', properties: { text: units_1.UNITS.COLOR } }
        }
    }
};
var directionToPadding = {
    row: 'right',
    'row-reverse': 'left',
    'column-reverse': 'top',
    column: 'bottom'
};
var placementToDirection = function (placement) {
    switch (placement) {
        case 'top':
        case 'none':
        case undefined:
            return 'column';
        case 'left':
            return 'row';
        case 'right':
            return 'row-reverse';
    }
};
var alignSettingToAlign = function (align) {
    switch (align) {
        case 'start':
        case undefined:
            return 'flex-start';
        case 'end':
            return 'flex-end';
        case 'center':
            return 'center';
    }
};
exports.makeField = function (settings) {
    var Label = exports.makeLabel(settings.label);
    var Error = exports.makeError(settings.error);
    var direction = placementToDirection(settings.label.placement);
    var align = alignSettingToAlign(settings.label.align);
    return function (props) {
        var _a;
        // Generate an id for the field if both id and name wasn't provided
        var _id = react_1.useMemo(function () { var _a, _b; return (_b = (_a = props.id) !== null && _a !== void 0 ? _a : props.name) !== null && _b !== void 0 ? _b : uuid_1.v4(); }, [props.id, props.name]);
        // default to valid
        var _invalid = (_a = props.invalid) !== null && _a !== void 0 ? _a : false;
        return direction === 'column' ? (react_1.default.createElement(Container, { className: props.className, direction: "column" },
            settings.label.placement !== 'none' && (react_1.default.createElement(Label, { align: align, padding: directionToPadding[direction], htmlFor: _id }, props.label)),
            props.children({ id: _id, 'aria-invalid': _invalid, name: props.name }),
            react_1.default.createElement(Error, null, props.errorMessage))) : (react_1.default.createElement(Container, { className: props.className, direction: direction },
            settings.label.placement !== 'none' && (react_1.default.createElement(Label, { align: align, basis: settings.label.fixedWidth, padding: directionToPadding[direction], htmlFor: _id }, props.label)),
            react_1.default.createElement(Column, { basis: settings.label.fixedWidth, align: "flex-start" },
                props.children({ id: _id, 'aria-invalid': _invalid, name: props.name }),
                react_1.default.createElement(Error, null, props.errorMessage))));
    };
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
